<ion-content class="container">
  <ion-row class="p-0">
    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="text-center">
      <img src="././assets/icon/phiedgeSidebarpoweredbyIcon.jpg" class="logoHeight mt-20 cp">
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="text-center">
      <button type="submit" class="text-center fs-16 fs_14ForMobile font_semibold centerContent login-btn" [style.background-color]="selectedTemplateColorCode">360 Review {{reviewName}}</button>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
      <div class="cardBox centerContent">
        <ion-row>
          <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">
            <div class="fs-16 fs_14ForMobile font_regular">Name</div>
          </ion-col>
          <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">
            <div class="fs-16 fs_14ForMobile font_regular">Company Name</div>
          </ion-col>
          <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">
            <div class="fs-16 fs_14ForMobile font_regular">Email ID</div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">
            <div class="fs-16 fs_14ForMobile font_bold">{{userName}}</div>
          </ion-col>
          <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">
            <div class="fs-16 fs_14ForMobile font_bold">{{companyName}}</div>
          </ion-col>
          <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">
            <div class="fs-16 fs_14ForMobile font_bold">{{email}}</div>
          </ion-col>
        </ion-row>
      </div>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" *ngFor="let question of questions; let i = index">
      <div class="cardBox_two mt-20 centerContent">
        <div class="headingOfShowBox_two font_medium fs-14 fs_12ForMobile" [style.background-color]="selectedTemplateColorCode">
        </div>
        <div class="p-20">
          <div class="fs-14 fs_12ForMobile font_regular">
            {{ i+1 }}. {{ question.question }} <span class="red-cl">*</span>
          </div>
    
          <!-- Open Ended Question Validation -->
          <div class="mt-10" *ngIf="question.questionType === 'Open Ended'">
            <mat-form-field class="custom-input w-100 mat-height40 mat-input-style">
              <textarea matInput 
                placeholder="Enter your answer" 
                rows="1" 
                maxlength="255" 
                required 
                [(ngModel)]="question.answer"
                (blur)="validateField(question)">
              </textarea>
            </mat-form-field>
            <div class="error-text" *ngIf="question.error">
              Answer is required.
            </div>
          </div>
    
          <!-- Rating Based Question Validation -->
          <div class="mt-10" *ngIf="question.questionType === 'Rating Based'">
            <ng-select 
              [clearable]="false" 
              class="w170 mat mat-height40" 
              placeholder="Select Rating" 
              required 
              [(ngModel)]="question.answer"
              (blur)="validateField(question)">
              <ng-option *ngFor="let rating of ratings" [value]="rating.rating">
                {{ rating.rating }}
              </ng-option> 
            </ng-select>
            <div class="error-text" *ngIf="question.error">
              Rating is required.
            </div>
          </div>
        </div>
      </div>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
      <div class="mt-20 centerContent">
        <button class="ess_Btn fs-14 fs_12ForMobile" [style.background-color]="selectedTemplateColorCode"
        (click)="submitResponse()">
          Submit
        </button>
      </div>
    </ion-col>
  </ion-row>
</ion-content>